var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3H13.125V0.814125C13.125 0.3645 12.7605 0 12.3109 0H5.68913C5.2395 0 4.875 0.3645 4.875 0.814125V3H0V4.5H1.75125L3.25125 16.0399C3.39713 17.1611 4.35225 18 5.4825 18H12.5175C13.6481 18 14.6029 17.1611 14.7488 16.0399L16.2488 4.5H18V3ZM6.375 1.5H11.625V3H6.375V1.5ZM13.2611 15.8468C13.2127 16.2191 12.8929 16.5 12.5175 16.5H5.4825C5.10675 16.5 4.78725 16.2191 4.73887 15.8468L3.264 4.5H14.7364L13.2611 15.8468Z",
    fill: "#031434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8768 5.93867L10.1273 14.9382L11.622 15.0627L12.3716 6.06317L10.8768 5.93867Z",
    fill: "#031434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12178 5.93762L5.62703 6.06212L6.37661 15.0616L7.87136 14.9371L7.12178 5.93762Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash_icon.cf4bb62c4eca45d46245babece1cf4e0.svg";
export { ForwardRef as ReactComponent };